import React, { lazy, Suspense } from 'react';

const LazyPasswordRecovery = lazy(async () => await import('./PasswordRecovery'));

const PasswordRecovery = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyPasswordRecovery {...props} />
  </Suspense>
);

export default PasswordRecovery;
